import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  watchlistModal: boolean;
  watchlist_sub_list: boolean;
  watchlist_id: null | number;
  watchlist_items: any[];
  watchlist_selected_items: any[];
};

const initialState: InitialState = {
  watchlistModal: false,
  watchlist_sub_list: false,
  watchlist_id: null,
  watchlist_items: [],
  watchlist_selected_items: [],
};

const watchlistModalSlice = createSlice({
  name: "watchlistModalSlice",
  initialState,
  reducers: {
    toggleWatchlistModal: (state, action: PayloadAction) => {
      state.watchlistModal = !state.watchlistModal;
      return state;
    },
    openSubWatchList: (
      state,
      action: PayloadAction<{ watchlist_id: number; watchlist_items: any[] }>
    ) => {
      state.watchlist_sub_list = true;
      state.watchlist_id = action.payload.watchlist_id;
      state.watchlist_items = action.payload.watchlist_items;
      state.watchlist_selected_items = [];
      return state;
    },
    setWatchlistItems: (state, action: PayloadAction<any>) => {
      const checkDuplicate = state.watchlist_selected_items.filter(
        (data) =>
          data.id === action.payload.id &&
          data.media_type === action.payload.media_type
      );
      if (checkDuplicate.length > 0) {
        return state;
      } else {
        state.watchlist_selected_items = [
          ...state.watchlist_selected_items,
          action.payload,
        ];
        return state;
      }
    },
    removeWatchlistItems: (state, action: PayloadAction<any>) => {
      const filteredTiles = state.watchlist_selected_items.filter(
        (data) =>
          data.id !== action.payload.id ||
          data.media_type !== action.payload.media_type
      );
      state.watchlist_selected_items = filteredTiles;
      return state;
    },
    resetSubWatchList: (state, action: PayloadAction<null>) => {
      state.watchlist_sub_list = false;
      state.watchlist_id = null;
      state.watchlist_selected_items = [];
      state.watchlist_items = [];
      return state;
    },
    shutDownWatchlistModal: (state, action: PayloadAction) => {
      state.watchlistModal = false;
      return state;
    },
  },
});

export const {
  toggleWatchlistModal,
  openSubWatchList,
  resetSubWatchList,
  setWatchlistItems,
  removeWatchlistItems,
  shutDownWatchlistModal
} = watchlistModalSlice.actions;
export default watchlistModalSlice;
